import React from 'react';
import { useTranslation } from 'react-i18next';
import Chart from '../../Components/Chart/Chart';
import Navbar from '../../Components/Navbar/Navbar';
import Sidebar from '../../Components/Sidebar/Sidebar';
import TableList from '../../Components/TableList/TableList';
import userPic from '../../Images/man2.jpg';
import './Detail.css';

function Detail() {
    const { t } = useTranslation();
    // const { userId, productId } = useParams();
    return (
        <div className="details">
            <div className="home_sidebar">
                <Sidebar />
            </div>

            <div className="detail_page_main">
                <Navbar />

                <div className="user_info">
                    <div className="user_detail">
                        <img src={userPic} alt="user" className="user_image" />

                        <div className="user_detailss">
                            <p className="name">{t('username')}: John</p>
                            <p>{t('email')}: johndoe33@gmail.com</p>
                            <p>{t('address')}: Berlin, Germany</p>
                            <p>
                                {t('status')}: {t('active')}
                            </p>
                        </div>
                    </div>

                    <div className="user_chart">
                        <Chart height={390} title={t('user_spending')} />
                    </div>
                </div>

                <div className="table">
                    <div className="title">{t('latest_transactions')}</div>
                    <TableList />
                </div>
            </div>
        </div>
    );
}

export default Detail;
